<template>
  <div class="col-lg-12 col-sm-12">
    <template v-if="successMessage == ''">
      <template v-if="!loading"> </template>
      <template v-else-if="loading == true">
        <li class="list-group-item">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw fa-mrbig"></i>
          <p>Estamos procesando su compra. Por favor, espere.</p>
        </li>
      </template>
    </template>

    <div :class="[successMessage === '' ? 'd-none' : 'alert alert-success']" role="alert">
      <button type="button" class="close" data-dismiss="alert" @click="hideMessages()">
        &times;</button
      ><strong>{{ successMessage }}<router-link to="/pedidos">aquí</router-link>.</strong>
    </div>
    <div :class="[errorMessage === '' ? 'd-none' : 'alert alert-danger']" role="alert">
      <button type="button" class="close" data-dismiss="alert" @click="hideMessages()">
        &times;</button
      ><strong><span v-html="errorMessage"></span></strong>
    </div>

    <template v-if="failPaymentCard">
      <h4>Detalles del pedido rechazado</h4>
      <div class="row">
        <div class="col-lg-6">
          <ul class="list-group mb-3">
            <li class="list-group-item" v-for="(item, index) in cartProducts" :key="index">
              <div class="row">
                <template v-if="item.subproduct.id_lote == 0">
                  <div class="col-6 col-sm-4 margen-automatico" style="text-align: left;">
                    <p>
                      <strong>{{ item.name_product_es }}</strong>
                    </p>
                  </div>
                </template>
                <template v-else>
                  <div class="col-6 col-sm-4 margen-automatico" style="text-align: left;">
                    <p>
                      <strong>{{
                        item.name_product_es + ' Lote: ' + item.subproduct.lote_sku
                      }}</strong>
                    </p>
                  </div>
                </template>

                <div class="col-6 col-sm-4 margen-automatico">
                  <p>
                    {{ item.price_product | currency }} X
                    <span class="span-cantidad-calculator"
                      ><strong>{{ item.qty }} </strong></span
                    >
                  </p>
                </div>
                <div class="col-12 col-sm-4 margen-automatico" style="text-align: left;">
                  <p>
                    <strong>{{ (item.price_product * item.qty) | currency }}*</strong>
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <small>*Los precios incluyen IGV</small>
          <hr />
        </div>
        <div class="col-lg-6">
          <ul class="list-group mb-3">
            <li class="list-group-item d-flex justify-content-between">
              <span>Subtotal:</span>
              {{ (totalValue - delivery_detail.delivery_cost) | currency }}
            </li>
            <li class="list-group-item d-flex justify-content-between">
              <span>Despacho:</span> {{ delivery_detail.delivery_cost | currency }}
            </li>

            <li class="list-group-item d-flex justify-content-between">
              <span><strong>Total:</strong></span>
              <strong>{{ totalValue | currency }}</strong>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import toastr from 'toastr';
import { config_settings } from '@/config.js';
import { mapState, mapActions, mapMutations } from 'vuex';
import { postCdpNiubiz } from '@/service/process.service';
import {
  generateChargueDataForVisanet,
  generateNewAccountForErpRequest,
} from '@/helpers/cart.helpers';
import {
  generateRefreshTokenBodyRequest,
  getAccessToken,
  deleteCartItems,
  setTokens,
  setNiubizSecurityToken,
} from '@/helpers/localStorage.helpers';
import { postLogin, postNewAccountToErp, getProfileData } from '@/service/account.service';
import { BAD_REQUEST, UNAUTHORIZED, BAD_GATEWAY } from '@/types/httpd.constants';

export default {
  name: 'Cart',
  props: ['transactionToken'],
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      id_delivery: localStorage.getItem('id_delivery'),
      day_delivery: localStorage.getItem('day_delivery'),
      ruc_agency: localStorage.getItem('ruc_agency'),
      dir_agency: localStorage.getItem('dir_agency'),
      cdp_data: JSON.parse(localStorage.getItem('cdp_details_for_visanet')),
      niubizSecurityToken: localStorage.getItem('niubizSecurityToken'),
      address_details: JSON.parse(localStorage.getItem('address_details')),
      totalValue: 0.0,
      products_data: [],
      loggedUserData: null,
      tipoCDP: '0',
      razsoc: '',
      facdir: '',
      ruc: '',
      delivery_detail: '',
      gen_delivery_cost: 0.0,
      successMessage: '',
      errorMessage: '',
      loading: false,
      failPaymentCard: false,
    };
  },
  computed: mapState(['cartProducts']),
  methods: {
    /* Resetting the store and localstorage after removing product from cart */
    ...mapMutations(['SET_CART_PRODUCTS']),
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    refreshToken() {
      const body = generateRefreshTokenBodyRequest();
      const refreshingCall = postLogin(body).then((response) => {
        setTokens(response.data.access_token, response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    getUserData() {
      getProfileData(getAccessToken())
        .then((response) => {
          this.loggedUserData = response.data;
          this.generateCharge();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.getUserData();
              })
              .catch((_) => {});
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    hideMessages() {
      this.successMessage = '';
      this.errorMessage = '';
    },

    removeAllProductCart() {
      var products = [];
      this.SET_CART_PRODUCTS(products);
      deleteCartItems();
      this.analizeCart();
    },

    generateCharge() {
      if (this.cdp_data.factura) {
        this.tipoCDP = 2;
        this.ruc = this.cdp_data.ruc;
        this.razsoc = this.cdp_data.companyName;
        this.facdir = this.cdp_data.billing_address;
      } else {
        this.tipoCDP = 1;
      }
      this.loading = true;
      this.cartProducts.forEach((product, index) => {
        this.products_data[index] = {
          code_product: product.code_product,
          quantity: product.qty,
          cod_sub_product: product.subproduct.id_lote,
        };
      });
      /*
      const newAccountForErpRequest = generateNewAccountForErpRequest(
        this.tipoCDP,
        this.loggedUserData,
        this.ruc,
        this.razsoc,
        this.address_details,
      );
      this.createAccountForErp(newAccountForErpRequest);
      */
      const chargueData = generateChargueDataForVisanet(
        this.transactionToken,
        this.niubizSecurityToken,
        this.loggedUserData,
        this.products_data,
        this.tipoCDP,
        this.ruc,
        this.razsoc,
        this.facdir,
        this.mail_confirm,
        this.operation_number,
        this.id_delivery,
        this.address_details,
        this.day_delivery,
        this.ruc_agency,
        this.dir_agency,
        this.origin_bank,
        this.destiny_bank,
      );
      var hoy = new Date();
      var fecha = hoy.getDate() + '/' + (hoy.getMonth() + 1) + '/' + hoy.getFullYear();
      var hora = hoy.getHours() + ':' + hoy.getMinutes();
      var FechaYhora = fecha + ' ' + hora;

      postCdpNiubiz(getAccessToken(), chargueData)
        .then((response) => {
          setNiubizSecurityToken('');
          this.removeAllProductCart();
          this.transactionToken = '';
          this.loading = false;
          this.successMessage =
            'Su compra fue efectuada correctamente, se le enviarán los detalles y el cargo a su correo electrónico. Tambien puede revisar el detalle de sus compras y pedidos. Tarjeta aprobada: ' +
            response.data.details.replace('The operation has been carried out successfully. ', '') +
            'Número de Pedido: 00000000001. Fecha: ' +
            FechaYhora;
          this.errorMessage = '';
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.generateCharge();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.errorMessage = 'Debe iniciar sesión antes de continuar';
                this.successMessage = '';
                this.$router.push({ path: '../../login/' });
              });
          } else if (error.response.status === BAD_REQUEST) {
            this.failPaymentCard = true;
            this.successMessage = '';
            this.errorMessage =
              'ERROR: Su tarjeta o alguno de los datos ingresados ha sido rechazado. Tarjeta Denegada: VISA ************4555. Por favor inténtelo nuevamente. Número de Pedido: 00000000002. Fecha: ' +
              FechaYhora;
          } else if (error.response.status === BAD_GATEWAY) {
            this.removeAllProductCart();
            this.successMessage =
              'Su compra fue efectuada correctamente, sin embargo, es posible que haya existido un error al enviarle los detalles de la transacción al correo electrónico. Puede revisar el detalle de sus compras y pedidos ';
            this.errorMessage = '';
          } else {
            this.successMessage = '';
            this.errorMessage =
              'Estimado cliente le informamos que no contamos con stock del producto solicitado, es posible que recientemente se haya agotado.';
          }
        });
    },

    createAccountForErp(userData) {
      postNewAccountToErp(userData)
        .then((response) => {})
        .catch((error) => {
          this.errorMessage = 'ATENCIÓN: Se presentó un error en el envio de información al ERP.';
        });
    },

    analizeCart() {
      let actual_total = 0.0;
      this.general_allowed_sale = true;
      this.cartProducts.forEach((product, index) => {
        if (product.allowed_sale == false) {
          this.general_allowed_sale = false;
        }
        if (product.allowed_tpv == false) {
          this.general_allowed_tpv = false;
        }
        var subtotal = (product.price_product / 1.18) * (product.qty * 1.18) * 100;
        subtotal = Math.round(subtotal) / 100.0;
        actual_total = actual_total + subtotal;
      });
      this.totalValue = Math.round((actual_total + this.gen_delivery_cost) * 100) / 100;
    },
  },

  created() {
    this.scrollToTop();
    this.getUserData();
  },
};
</script>
